import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Partner } from '../../models/partner';
import { PartnerStateService } from '../../services/partner-state.service';
import { PartnerStateEnum } from '../../services/partner-state.enum';

@Component({
  selector: 'app-new-child',
  templateUrl: './new-child.component.html',
  styleUrls: ['./new-child.component.css']
})
export class NewChildComponent implements OnInit {

  child: Partner;
  parent: Partner;

  actionInProgress: boolean;

  private _partnerFormIsValid: boolean;

  constructor(
    private partnerStateService: PartnerStateService
  ) {
  }

  ngOnInit() {
    this.child = new Partner();
    this.parent = new Partner();
  }

  get isSaveButtonEnabled(): boolean {
    return this._partnerFormIsValid && !this.actionInProgress && this.parent.waiver;
  }

  cancelClick() {
    this.partnerStateService.update(PartnerStateEnum.ShowChildrenList);
  }

  saveClick() {
    this.actionInProgress = true;
    this.partnerStateService.createChild(this.child).subscribe(result => {
      if (result) {
        this.partnerStateService.update(PartnerStateEnum.ShowChildrenList);
      }
      this.actionInProgress = false;
    });
  }

  onChildFormInvalid() {
    this._partnerFormIsValid = false;
  }

  onChildFormValid() {
    this._partnerFormIsValid = true;
  }
}
